var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRecordingAnimated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.89062,
    cy: 8,
    r: 3,
    fill: "#e2e2e2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    from: "#e2e2e2",
    to: "#ffffff",
    dur: "1.5s",
    repeatCount: "indefinite",
    calcMode: "discrete"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0827 10.341H11.7862L13.6414 14H16L13.9034 10.0292C15.0483 9.57869 15.7103 8.46988 15.7103 7.18782C15.7103 5.21276 14.3656 4 12.1793 4H8V14H10.0827V10.341ZM10.0827 5.63549H11.8896C12.9242 5.63549 13.5724 6.24534 13.5724 7.21555C13.5724 8.20655 12.9587 8.78174 11.9104 8.78174H10.0827V5.63549Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.2744H18.8954V9.74501H22.7677V8.13724H18.8954V5.72558H23V4H17V14H23V12.2744Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1534 14C30.2884 14 31.8466 12.6091 32 10.5788H30.1963C30.0183 11.6269 29.2209 12.2992 28.1594 12.2992C26.7608 12.2992 25.8957 11.0336 25.8957 8.99671C25.8957 6.95979 26.7608 5.69413 28.1534 5.69413C29.2086 5.69413 30.0122 6.41925 30.1901 7.52011H31.9938C31.8589 5.4766 30.2515 4 28.1534 4C25.5829 4 24 5.90508 24 8.99671C24 12.0883 25.5889 14 28.1534 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecordingAnimated);
export default __webpack_public_path__ + "static/media/icon-recording-animated.f5ebb78b5dde05707c7c99631a775939.svg";
export { ForwardRef as ReactComponent };